/**
 * Check if any control in form is invalid and focus on it
 * @param formId - selector of form to check for invalid controls
 * @param el - element to search for invalid controls
 * @returns true if any control is invalid, false otherwise
 */
export function isAnyControlInvalid(formId: string, el: HTMLElement): boolean {
  const firstInvalidControl: HTMLElement = el.querySelector("#" + formId + " .ng-invalid");
  if (firstInvalidControl) {
    firstInvalidControl.focus();
    return true;
  }
  return false;
}
